import { useEffect, useState, Suspense } from 'react'
import axios from 'axios'
import DashboardLayout from './layout'
import { useTranslation } from 'react-i18next'
import { API_BASE_URL, X_API_KEY } from '../../services/api'
import GalleryMegaEdit from '../components/GalleryMegaEdit'
import CookieManager from '../lib/CookiesManager'
import * as Sentry from '@sentry/react'

interface FormProps {
  userProfileFormProps: any
  formData: any
  handleFieldChange: (field: string, value: any) => void
}

const MyGallery = () => {
  const [userStatus, setUserStatus] = useState<string[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const { t } = useTranslation()

  useEffect(() => {
    const fetchUserData = async () => {
      const email = CookieManager.getEmail()
      if (!email) {
        setIsLoading(false)
        return
      }

      try {
        const response = await axios.get(`${API_BASE_URL}/all/full`, {
          headers: {
            'x-api-key': X_API_KEY,
          },
        })
        if (response.data?.users) {
          const user = response.data.users.find(
            (u: { email: string }) => u.email === email,
          )
          if (user?.status) {
            setUserStatus(
              Array.isArray(user.status) ? user.status : [user.status],
            )
          }
        }
      } catch (error) {
        Sentry.captureException(error, {
          extra: {
            action: 'fetchUserData',
            timestamp: new Date().toISOString(),
          },
          tags: {
            type: 'api_error',
            method: 'fetchUserData',
          },
        })
      } finally {
        setIsLoading(false)
      }
    }

    fetchUserData()
  }, [])

  const getGalleryComponent = (): React.ComponentType<FormProps> => {
    if (userStatus.includes('private, escort, massage')) {
      return GalleryMegaEdit
    }
    if (
      userStatus.includes('maison privee') ||
      userStatus.includes(
        'maison privee, bars et clubs prive, salons de massage, hotels coquins, saunas prives, clubs echangistes, event',
      )
    ) {
      return GalleryMegaEdit
    }
    if (userStatus.includes('libertins ou visiteur')) {
      return GalleryMegaEdit
    }
    return () => null
  }

  const GalleryComponent = getGalleryComponent()

  const handleFieldChange = (field: string, value: any) => {
    console.log('Field changed:', field, value)
  }

  if (isLoading) {
    return (
      <DashboardLayout title={t('dashboard.my-gallery')}>
        <div className='flex justify-center items-center h-full'>
          {t('loading')}...
        </div>
      </DashboardLayout>
    )
  }

  return (
    <DashboardLayout title={t('dashboard.my-gallery')}>
      <Suspense
        fallback={
          <div className='flex justify-center items-center h-full'>
            {t('loading')}...
          </div>
        }
      >
        <div className='px-2'>
          <GalleryComponent
            userProfileFormProps={{}}
            formData={{}}
            handleFieldChange={handleFieldChange}
          />
        </div>
      </Suspense>
    </DashboardLayout>
  )
}

export default MyGallery
